'use strict';

// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************

'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ROOT_FONT_SIZE = exports.ROOT_FONT_SIZE = '16px';
var NAV_BAR_HEIGHT = exports.NAV_BAR_HEIGHT = '42px';
var NAV_ITEM_INNER_SPACING_X = exports.NAV_ITEM_INNER_SPACING_X = '8px';
var NAV_ITEM_PADDING_LEFT = exports.NAV_ITEM_PADDING_LEFT = '12px';
var NAV_ITEM_PADDING_RIGHT = exports.NAV_ITEM_PADDING_RIGHT = '12px';
var NAV_ITEM_PADDING_X = exports.NAV_ITEM_PADDING_X = '24px';
var NAV_ITEM_PADDING_Y = exports.NAV_ITEM_PADDING_Y = '12px';
var ALERT_FONT_SIZE = exports.ALERT_FONT_SIZE = '14px';
var SMALL_CLOSE_BUTTON_SIZE = exports.SMALL_CLOSE_BUTTON_SIZE = '8px';
var MEDIUM_CLOSE_BUTTON_SIZE = exports.MEDIUM_CLOSE_BUTTON_SIZE = '12px';
var EXTRA_LARGE_CLOSE_BUTTON_SIZE = exports.EXTRA_LARGE_CLOSE_BUTTON_SIZE = '36px';
var CHEVRON_FONT_SIZE = exports.CHEVRON_FONT_SIZE = '12px';
var CHEVRON_PADDING_X = exports.CHEVRON_PADDING_X = '12px';
var CHEVRON_PADDING_Y = exports.CHEVRON_PADDING_Y = '4px';
var EMPTY_STATE_PADDING_X = exports.EMPTY_STATE_PADDING_X = '56px';
var EMPTY_STATE_PADDING_Y = exports.EMPTY_STATE_PADDING_Y = '20px';
var DISTANCE_MEASUREMENT_EXTRA_SMALL = exports.DISTANCE_MEASUREMENT_EXTRA_SMALL = '8px';
var DISTANCE_MEASUREMENT_SMALL = exports.DISTANCE_MEASUREMENT_SMALL = '12px';
var DISTANCE_MEASUREMENT_MEDIUM = exports.DISTANCE_MEASUREMENT_MEDIUM = '24px';
var DISTANCE_MEASUREMENT_LARGE = exports.DISTANCE_MEASUREMENT_LARGE = '32px';
var DISTANCE_MEASUREMENT_EXTRA_LARGE = exports.DISTANCE_MEASUREMENT_EXTRA_LARGE = '64px';
var DRAG_HANDLE_HEIGHT = exports.DRAG_HANDLE_HEIGHT = '24px';
var DRAG_HANDLE_OFFSET_Y = exports.DRAG_HANDLE_OFFSET_Y = '12px';
var DRAG_HANDLE_OFFSET_X = exports.DRAG_HANDLE_OFFSET_X = '9px';
var DRAG_HANDLE_WIDTH = exports.DRAG_HANDLE_WIDTH = '5px';
var INPUT_FONT_SIZE = exports.INPUT_FONT_SIZE = '16px';
var INPUT_SM_FONT_SIZE = exports.INPUT_SM_FONT_SIZE = '14px';
var INPUT_XXL_FONT_SIZE = exports.INPUT_XXL_FONT_SIZE = '32px';
var INPUT_BORDER_WIDTH = exports.INPUT_BORDER_WIDTH = '1px';
var INPUT_DEFAULT_PADDING_X = exports.INPUT_DEFAULT_PADDING_X = '10px';
var INPUT_DEFAULT_PADDING_Y = exports.INPUT_DEFAULT_PADDING_Y = '10px';
var INPUT_XXL_LINE_HEIGHT = exports.INPUT_XXL_LINE_HEIGHT = '40px';
var INPUT_XXL_PADDING_X = exports.INPUT_XXL_PADDING_X = '16px';
var INPUT_XXL_PADDING_Y = exports.INPUT_XXL_PADDING_Y = '16px';
var INPUT_DEFAULT_HEIGHT = exports.INPUT_DEFAULT_HEIGHT = '40px';
var INPUT_SM_HEIGHT = exports.INPUT_SM_HEIGHT = '32px';
var SLIDER_CONTROL_SIZE = exports.SLIDER_CONTROL_SIZE = '20px';
var LABEL_DEFAULT_PADDING_TOP = exports.LABEL_DEFAULT_PADDING_TOP = '8px';
var LABEL_DEFAULT_PADDING_BOTTOM = exports.LABEL_DEFAULT_PADDING_BOTTOM = '4px';
var BASE_FONT_SIZE = exports.BASE_FONT_SIZE = '14px';
var BASE_LINE_HEIGHT = exports.BASE_LINE_HEIGHT = '24px';
var BASE_SINGLE_DIRECTION_MARGIN = exports.BASE_SINGLE_DIRECTION_MARGIN = '20px';
var BASE_SPACING_X = exports.BASE_SPACING_X = '12px';
var BASE_SPACING_Y = exports.BASE_SPACING_Y = '6px';
var BASE_ICON_SPACING_X = exports.BASE_ICON_SPACING_X = '8px';
var INLINE_ICON_SPACING_X = exports.INLINE_ICON_SPACING_X = '4px';
var HEADING0 = exports.HEADING0 = '55px';
var HEADING1 = exports.HEADING1 = '32px';
var HEADING2 = exports.HEADING2 = '24px';
var HEADING3 = exports.HEADING3 = '22px';
var HEADING4 = exports.HEADING4 = '20px';
var HEADING5 = exports.HEADING5 = '16px';
var HEADING6 = exports.HEADING6 = '14px';
var HEADING7 = exports.HEADING7 = '14px';
var PAGE_TITLE_FONT_SIZE = exports.PAGE_TITLE_FONT_SIZE = '28px';
var MICROCOPY_SIZE = exports.MICROCOPY_SIZE = '12px';
var MICROCOPY_LINE_HEIGHT = exports.MICROCOPY_LINE_HEIGHT = '18px';
var FORM_COPY_SIZE = exports.FORM_COPY_SIZE = '16px';
var FORM_SET_VALIDATION_TOP_SPACING = exports.FORM_SET_VALIDATION_TOP_SPACING = '9px';
var FORM_SET_VERTICAL_SEPARATION = exports.FORM_SET_VERTICAL_SEPARATION = '12px';
var BUTTON_BORDER_WIDTH = exports.BUTTON_BORDER_WIDTH = '1px';
var BUTTON_XS_FONT_SIZE = exports.BUTTON_XS_FONT_SIZE = '12px';
var BUTTON_SM_FONT_SIZE = exports.BUTTON_SM_FONT_SIZE = '12px';
var BUTTON_DEFAULT_FONT_SIZE = exports.BUTTON_DEFAULT_FONT_SIZE = '14px';
var BUTTON_LG_FONT_SIZE = exports.BUTTON_LG_FONT_SIZE = '44px';
var BUTTON_DEFAULT_PADDING_X = exports.BUTTON_DEFAULT_PADDING_X = '24px';
var BUTTON_DEFAULT_PADDING_Y = exports.BUTTON_DEFAULT_PADDING_Y = '12px';
var BUTTON_XS_WIDTH = exports.BUTTON_XS_WIDTH = '26px';
var BUTTON_XS_PADDING_X = exports.BUTTON_XS_PADDING_X = '12px';
var BUTTON_XS_PADDING_Y = exports.BUTTON_XS_PADDING_Y = '6px';
var BUTTON_SM_WIDTH = exports.BUTTON_SM_WIDTH = '32px';
var BUTTON_SM_PADDING_X = exports.BUTTON_SM_PADDING_X = '16px';
var BUTTON_SM_PADDING_Y = exports.BUTTON_SM_PADDING_Y = '9px';
var BUTTON_LG_WIDTH = exports.BUTTON_LG_WIDTH = '40px';
var BUTTON_LG_PADDING_X = exports.BUTTON_LG_PADDING_X = '18px';
var BUTTON_LG_PADDING_Y = exports.BUTTON_LG_PADDING_Y = '17px';
var BUTTON_RADIUS = exports.BUTTON_RADIUS = '3px';
var PAGINATION_BUTTON_FONT_SIZE = exports.PAGINATION_BUTTON_FONT_SIZE = '14px';
var PAGINATION_BUTTON_LABEL_FONT_SIZE = exports.PAGINATION_BUTTON_LABEL_FONT_SIZE = '14px';
var SELECTABLE_BUTTON_MAX_WIDTH = exports.SELECTABLE_BUTTON_MAX_WIDTH = '200px';
var SELECTABLE_BUTTON_LARGE_MIN_HEIGHT = exports.SELECTABLE_BUTTON_LARGE_MIN_HEIGHT = '180px';
var SELECTABLE_BUTTON_SMALL_HEIGHT = exports.SELECTABLE_BUTTON_SMALL_HEIGHT = '56px';
var TABLE_DEFAULT_FONT_SIZE = exports.TABLE_DEFAULT_FONT_SIZE = '14px';
var TABLE_DEFAULT_PADDING_Y = exports.TABLE_DEFAULT_PADDING_Y = '16px';
var TABLE_DEFAULT_PADDING_X = exports.TABLE_DEFAULT_PADDING_X = '24px';
var TABLE_CELL_HEIGHT = exports.TABLE_CELL_HEIGHT = '72px';
var TABLE_HEADER_FONT_SIZE = exports.TABLE_HEADER_FONT_SIZE = '12px';
var TABLE_HEADER_PADDING_Y = exports.TABLE_HEADER_PADDING_Y = '14px';
var TABLE_HEADER_PADDING_TOP = exports.TABLE_HEADER_PADDING_TOP = '8px';
var TABLE_HEADER_PADDING_BOTTOM = exports.TABLE_HEADER_PADDING_BOTTOM = '4px';
var TABLE_HEADER_HEIGHT = exports.TABLE_HEADER_HEIGHT = '44px';
var TABLE_COMPACT_PADDING_Y = exports.TABLE_COMPACT_PADDING_Y = '8px';
var TABLE_COMPACT_HEADER_HEIGHT = exports.TABLE_COMPACT_HEADER_HEIGHT = '56px';
var TABLE_COMPACT_CELL_HEIGHT = exports.TABLE_COMPACT_CELL_HEIGHT = '56px';
var CARD_PADDING = exports.CARD_PADDING = '40px';
var CARD_PADDING_COMPACT = exports.CARD_PADDING_COMPACT = '24px';
var CARD_SHADOW_ALPHA = exports.CARD_SHADOW_ALPHA = '.12';
var CARD_SHADOW_BLUR_RADIUS = exports.CARD_SHADOW_BLUR_RADIUS = '5px';
var CARD_SHADOW_OFFSET_Y = exports.CARD_SHADOW_OFFSET_Y = '1px';
var ALERT_PADDING = exports.ALERT_PADDING = '20px';
var ALERT_PADDING_X = exports.ALERT_PADDING_X = '20px';
var ALERT_PADDING_Y = exports.ALERT_PADDING_Y = '8px';
var ALERT_HEIGHT = exports.ALERT_HEIGHT = '60px';
var DROP_SMALL_HEIGHT = exports.DROP_SMALL_HEIGHT = '72px';
var DROP_LARGE_HEIGHT = exports.DROP_LARGE_HEIGHT = '200px';
var INLINE_DIVIDED_LIST_SPACING_X = exports.INLINE_DIVIDED_LIST_SPACING_X = '8px';
var MODAL_HEADER_HEIGHT = exports.MODAL_HEADER_HEIGHT = '68px';
var MODAL_HEADER_PADDING_X = exports.MODAL_HEADER_PADDING_X = '40px';
var MODAL_BODY_PADDING_X = exports.MODAL_BODY_PADDING_X = '40px';
var MODAL_BODY_PADDING_Y = exports.MODAL_BODY_PADDING_Y = '40px';
var MODAL_FOOTER_PADDING_X = exports.MODAL_FOOTER_PADDING_X = '40px';
var MODAL_FOOTER_PADDING_Y = exports.MODAL_FOOTER_PADDING_Y = '24px';
var MODAL_CLOSE_BUTTON_SIZE = exports.MODAL_CLOSE_BUTTON_SIZE = '16px';
var MODAL_CLOSE_BUTTON_OFFSET = exports.MODAL_CLOSE_BUTTON_OFFSET = '24px';
var MODAL_SHORT_HEIGHT = exports.MODAL_SHORT_HEIGHT = '250px';
var MODAL_MEDIUM_HEIGHT = exports.MODAL_MEDIUM_HEIGHT = '408px';
var MODAL_TALL_HEIGHT = exports.MODAL_TALL_HEIGHT = '700px';
var MODAL_OVERLAY_PADDING_Y = exports.MODAL_OVERLAY_PADDING_Y = '60px';
var MODAL_PANEL_PADDING_X = exports.MODAL_PANEL_PADDING_X = '40px';
var MODAL_PANEL_PADDING_Y = exports.MODAL_PANEL_PADDING_Y = '24px';
var MODAL_PANEL_HEADER_PADDING_Y = exports.MODAL_PANEL_HEADER_PADDING_Y = '26px';
var MODAL_PANEL_FOOTER_PADDING_Y = exports.MODAL_PANEL_FOOTER_PADDING_Y = '20px';
var TEXT_AREA_CODE_HEIGHT = exports.TEXT_AREA_CODE_HEIGHT = '155px';
var TOOLBAR_HEIGHT_DARK = exports.TOOLBAR_HEIGHT_DARK = '56px';
var TOOLTIP_ARROW_SIZE = exports.TOOLTIP_ARROW_SIZE = '12px';
var TOOLTIP_MAX_WIDTH = exports.TOOLTIP_MAX_WIDTH = '232px';
var TOOLTIP_FONT_SIZE = exports.TOOLTIP_FONT_SIZE = '13px';
var TOOLTIP_HEADING_SIZE = exports.TOOLTIP_HEADING_SIZE = '16px';
var TOOLTIP_LONGFORM_FONT_SIZE = exports.TOOLTIP_LONGFORM_FONT_SIZE = '12px';
var TOOLTIP_LONGFORM_HEADING_SIZE = exports.TOOLTIP_LONGFORM_HEADING_SIZE = '14px';
var TOOLTIP_LONGFORM_PADDING = exports.TOOLTIP_LONGFORM_PADDING = '20px';
var TOOLTIP_PADDING = exports.TOOLTIP_PADDING = '10px';
var TOOLTIP_PADDING_Y = exports.TOOLTIP_PADDING_Y = '10px';
var TOOLTIP_PADDING_X = exports.TOOLTIP_PADDING_X = '16px';
var POPOVER_PADDING_Y = exports.POPOVER_PADDING_Y = '20px';
var POPOVER_PADDING_X = exports.POPOVER_PADDING_X = '24px';
var POPOVER_ARROW_SIZE = exports.POPOVER_ARROW_SIZE = '16px';
var DROPDOWN_MENU_HEIGHT = exports.DROPDOWN_MENU_HEIGHT = '220px';
var DROPDOWN_ITEM_DEFAULT_HEIGHT = exports.DROPDOWN_ITEM_DEFAULT_HEIGHT = '40px';
var DROPDOWN_FONT_SIZE = exports.DROPDOWN_FONT_SIZE = '14px';
var DROPDOWN_PADDING_Y = exports.DROPDOWN_PADDING_Y = '8px';
var DROPDOWN_PADDING_X = exports.DROPDOWN_PADDING_X = '20px';
var DROPDOWN_CARET_OFFSET_X = exports.DROPDOWN_CARET_OFFSET_X = '16px';
var TAB_FONT_SIZE = exports.TAB_FONT_SIZE = '14px';
var TAB_INDICATOR_HEIGHT = exports.TAB_INDICATOR_HEIGHT = '5px';
var TAB_PADDING_Y = exports.TAB_PADDING_Y = '12px';
var TAB_PADDING_X = exports.TAB_PADDING_X = '28px';
var TOGGLE_BUTTON_SIZE = exports.TOGGLE_BUTTON_SIZE = '20px';
var TOGGLE_BUTTON_SIZE_SMALL = exports.TOGGLE_BUTTON_SIZE_SMALL = '16px';
var HEADER_PADDING_TOP = exports.HEADER_PADDING_TOP = '42px';
var HEADER_PADDING_BOTTOM = exports.HEADER_PADDING_BOTTOM = '24px';
var LAYOUT_MAIN_PADDING_TOP = exports.LAYOUT_MAIN_PADDING_TOP = '40px';
var LAYOUT_MAX_WIDTH = exports.LAYOUT_MAX_WIDTH = '1280px';
var LAYOUT_NARROW_WIDTH = exports.LAYOUT_NARROW_WIDTH = '1140px';
var LAYOUT_PADDING_X = exports.LAYOUT_PADDING_X = '48px';
var LAYOUT_EDITOR_PADDING = exports.LAYOUT_EDITOR_PADDING = '20px';
var BACK_BUTTON_ARROW_SIZE = exports.BACK_BUTTON_ARROW_SIZE = '22px';
var BADGE_FONT_SIZE = exports.BADGE_FONT_SIZE = '14px';
var BADGE_ROUNDED_FONT_SIZE = exports.BADGE_ROUNDED_FONT_SIZE = '10px';
var BADGE_ROUNDED_HEIGHT = exports.BADGE_ROUNDED_HEIGHT = '20px';
var BADGE_ROUNDED_OFFSET_RIGHT = exports.BADGE_ROUNDED_OFFSET_RIGHT = '4px';
var BADGE_ROUNDED_OFFSET_TOP = exports.BADGE_ROUNDED_OFFSET_TOP = '8px';
var BADGE_ROUNDED_PADDING_LEFT = exports.BADGE_ROUNDED_PADDING_LEFT = '10px';
var BADGE_ROUNDED_PADDING_RIGHT = exports.BADGE_ROUNDED_PADDING_RIGHT = '6px';
var TAG_FONT_SIZE = exports.TAG_FONT_SIZE = '12px';
var TAG_FONT_SIZE_LARGE = exports.TAG_FONT_SIZE_LARGE = '14px';
var TAG_HEIGHT = exports.TAG_HEIGHT = '24px';
var TAG_PADDING_X = exports.TAG_PADDING_X = '8px';
var TAG_PADDING_Y = exports.TAG_PADDING_Y = '0';
var TAG_ICON_SPACING_X = exports.TAG_ICON_SPACING_X = '8px';
var TILE_CLOSE_BUTTON_OFFSET = exports.TILE_CLOSE_BUTTON_OFFSET = '12px';
var TILE_PADDING = exports.TILE_PADDING = '32px';
var TILE_PADDING_COMPACT = exports.TILE_PADDING_COMPACT = '20px';
var TILE_VERTICAL_SEPARATION = exports.TILE_VERTICAL_SEPARATION = '16px';
var MERCURY_LAYER = exports.MERCURY_LAYER = '1';
var VENUS_LAYER = exports.VENUS_LAYER = '2';
var EARTH_LAYER = exports.EARTH_LAYER = '1000';
var MARS_LAYER = exports.MARS_LAYER = '1070';
var JUPITER_LAYER = exports.JUPITER_LAYER = '1111';
var SATURN_LAYER = exports.SATURN_LAYER = '1112';
var URANUS_LAYER = exports.URANUS_LAYER = '1211';
var AVATAR_SIZE_EXTRA_SMALL = exports.AVATAR_SIZE_EXTRA_SMALL = '24px';
var AVATAR_SIZE_SMALL = exports.AVATAR_SIZE_SMALL = '32px';
var AVATAR_SIZE_MEDIUM = exports.AVATAR_SIZE_MEDIUM = '48px';
var AVATAR_SIZE_LARGE = exports.AVATAR_SIZE_LARGE = '72px';
var AVATAR_SIZE_EXTRA_LARGE = exports.AVATAR_SIZE_EXTRA_LARGE = '110px';
var WELL_ACTION_SMALL_FONT_SIZE = exports.WELL_ACTION_SMALL_FONT_SIZE = '12px';
var WELL_BIG_NUMBER_FONT_SIZE = exports.WELL_BIG_NUMBER_FONT_SIZE = '48px';
var WELL_BIG_NUMBER_LINE_HEIGHT = exports.WELL_BIG_NUMBER_LINE_HEIGHT = '66px';
var WELL_BIG_NUMBER_SMALL_FONT_SIZE = exports.WELL_BIG_NUMBER_SMALL_FONT_SIZE = '28px';
var WELL_BIG_NUMBER_SMALL_LINE_HEIGHT = exports.WELL_BIG_NUMBER_SMALL_LINE_HEIGHT = '38px';
var WELL_LABEL_FONT_SIZE = exports.WELL_LABEL_FONT_SIZE = '13px';
var WELL_LABEL_SMALL_FONT_SIZE = exports.WELL_LABEL_SMALL_FONT_SIZE = '12px';
var WELL_GUTTER_WIDTH = exports.WELL_GUTTER_WIDTH = '12px';
var WELL_HELP_TEXT_FONT_SIZE = exports.WELL_HELP_TEXT_FONT_SIZE = '14px';
var WELL_ITEM_WIDTH = exports.WELL_ITEM_WIDTH = '180px';
var WELL_VERTICAL_SEPARATION = exports.WELL_VERTICAL_SEPARATION = '24px';
var WELL_VERTICAL_SEPARATION_TOP = exports.WELL_VERTICAL_SEPARATION_TOP = '18px';
var WELL_VERTICAL_SEPARATION_BOTTOM = exports.WELL_VERTICAL_SEPARATION_BOTTOM = '32px';
var BASE_SHADOW_ALPHA = exports.BASE_SHADOW_ALPHA = '.08';
var BASE_SHADOW_BLUR_RADIUS = exports.BASE_SHADOW_BLUR_RADIUS = '24px';
var BASE_SHADOW_OFFSET_Y = exports.BASE_SHADOW_OFFSET_Y = '1px';
var GRID_BREAKPOINT_EXTRA_SMALL = exports.GRID_BREAKPOINT_EXTRA_SMALL = '0px';
var GRID_BREAKPOINT_SMALL = exports.GRID_BREAKPOINT_SMALL = '544px';
var GRID_BREAKPOINT_MEDIUM = exports.GRID_BREAKPOINT_MEDIUM = '768px';
var GRID_BREAKPOINT_LARGE = exports.GRID_BREAKPOINT_LARGE = '992px';
var GRID_BREAKPOINT_EXTRA_LARGE = exports.GRID_BREAKPOINT_EXTRA_LARGE = '1200px';
var DEVICE_FRAME_DESKTOP_WIDTH_RATIO = exports.DEVICE_FRAME_DESKTOP_WIDTH_RATIO = '16';
var DEVICE_FRAME_DESKTOP_HEIGHT_RATIO = exports.DEVICE_FRAME_DESKTOP_HEIGHT_RATIO = '10';
var DEVICE_FRAME_TABLET_WIDTH_RATIO = exports.DEVICE_FRAME_TABLET_WIDTH_RATIO = '3';
var DEVICE_FRAME_TABLET_HEIGHT_RATIO = exports.DEVICE_FRAME_TABLET_HEIGHT_RATIO = '4';
var DEVICE_FRAME_MOBILE_WIDTH_RATIO = exports.DEVICE_FRAME_MOBILE_WIDTH_RATIO = '9';
var DEVICE_FRAME_MOBILE_HEIGHT_RATIO = exports.DEVICE_FRAME_MOBILE_HEIGHT_RATIO = '19.5';
var DEVICE_FRAME_DESKTOP_HEADER_HEIGHT = exports.DEVICE_FRAME_DESKTOP_HEADER_HEIGHT = '23px';
var DEVICE_FRAME_TABLET_HEADER_HEIGHT = exports.DEVICE_FRAME_TABLET_HEADER_HEIGHT = '7%';
var DEVICE_FRAME_MOBILE_HEADER_HEIGHT = exports.DEVICE_FRAME_MOBILE_HEADER_HEIGHT = '7%';
var DEVICE_FRAME_MOBILE_FOOTER_HEIGHT = exports.DEVICE_FRAME_MOBILE_FOOTER_HEIGHT = '7%';
var DEVICE_FRAME_TABLET_HEADER_CIRCLE = exports.DEVICE_FRAME_TABLET_HEADER_CIRCLE = '10px';
var DEVICE_FRAME_MOBILE_HEADER_CIRCLE = exports.DEVICE_FRAME_MOBILE_HEADER_CIRCLE = '5px';
var DEVICE_FRAME_CAMERA_SPEAKER_SPACING = exports.DEVICE_FRAME_CAMERA_SPEAKER_SPACING = '4px';
var DEVICE_FRAME_BORDER_RADIUS = exports.DEVICE_FRAME_BORDER_RADIUS = '6px';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/HubStyleTokens/static-2.93/js/sizes.js
// module id = 14
// module chunks = 0